import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions } from "store/actions";

function useInitLoadLookups({ userId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (userId) {
      dispatch(actions.fetchUserDomains(userId));
      dispatch(actions.fetchUserSubDomains(userId));
      dispatch(actions.fetchCurrencies());
      dispatch(actions.fetchBillingEntity());

      // add more lookups if need
    }
  }, [userId]);
}

export default useInitLoadLookups;
